import store from 'config/store'
import { pathOr } from 'ramda'

export const hasGate = (name: string): boolean =>
  pathOr<boolean>(
    false,
    ['embed', 'configuration', 'gates', name],
    store.getState()
  )
